import React from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import { get, orderBy } from "lodash";
import schema from "./reviewCompsTables";
import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { buildAddress } from "../utils/operations";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Sorty } from "../../../common/js/icons";
import { Tooltip } from "react-tooltip";
import { styled } from "@mui/material/styles";

const PageToolbar = styled('div')(({ theme }) => ({
    marginBottom: "20px",
    marginTop: "20px",
}));

const TabOne = styled('div')(({ theme }) => ({
    marginRight: "20px",
}));

const ConnectorLine = styled('div')(({ theme }) => ({
    transition: theme.transitions.create("border-color"),
}));

const ConnectorActive = styled('div')(({ theme }) => ({
    "& ${ConnectorLine}": {
        borderColor: theme.palette.secondary.main,
    },
}));

const ConnectorCompleted = styled('div')(({ theme }) => ({
    "& ${ConnectorLine}": {
        borderColor: theme.palette.primary.main,
    },
}));

const ConnectorDisabled = styled('div')(({ theme }) => ({
    "& ${ConnectorLine}": {
        borderColor: theme.palette.grey[100],
    },
}));

const ListingIdLink = styled('span')(({ theme }) => ({
    "&:hover": {
        cursor: "pointer",
        textDecoration: "underline",
    },
    color: "#2C99D2",
    fontWeight: 600,
}));

const StyledPaper = styled('div')(({ theme }) => ({
    position: "absolute",
    width: theme.spacing(60),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    borderRadius: "3px",
    "&:focus": {
        outline: "none",
    },
}));

const MenuCategory = styled('div')(({ theme }) => ({
    fontSize: "13px",
    fontWeight: 800,
    "&>a:hover": {
        backgroundColor: "#ffffff !important",
        cursor: "default",
    },
    "&>a:focus": {
        outline: "none",
    },
    "&>a": {
        color: "#999999 !important",
    },
}));

const MenuSubItem = styled('div')(({ theme }) => ({
    "&>a": {
        paddingLeft: "30px !important",
    },
}));

const MenuRequestListing = styled('div')(({ theme }) => ({
    paddingBottom: "0px",
    "&>a": {
        paddingBottom: "0px !important",
    },
    "&>a:hover": {
        backgroundColor: "#ffffff !important",
        cursor: "default",
    },
    "&>a:focus": {
        outline: "none",
    },
}));

const AlternateContent = styled('div')(({ theme }) => ({
    margin: "auto",
    textAlign: "center",
    marginTop: "4em",
    marginBottom: "1em",
}));

const StyledLink = styled(Link)(({ theme }) => ({
    textDecoration: "none",
}));

const Sortable = styled('span')(({ theme }) => ({
    paddingRight: "5px",
    paddingBottom: "3px",
}));

const TableContainer = styled('div')({
    width: '100%',
    overflowX: 'auto',
});

const TableWrapper = styled('div')({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
});

const CompsTable = (props) => {
    const { handleSort, isLoading, comps, compTab } = props;

    let columnToSort = "transactionDate";
    let sortDirection = "asc";

    let compz = orderBy(comps, columnToSort, sortDirection);

    return (
        <div>
            <div style={{ display: 'flex', width: '100%' }}>
                <div style={{ flex: '1 1 auto' }}>
                    <div className="simPaper">
                        <TableContainer>
                            <TableWrapper>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {schema.viewHeaders[compTab].map((x, i) => (
                                                <TableCell key={`thc-${i}`}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                        onClick={() => handleSort(x.sort ? x.sort : x.prop)}
                                                    >
                                                        <Sortable>{x.name}</Sortable>
                                                        {x.name && (
                                                            <div>
                                                                <Sorty />
                                                            </div>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    {!isLoading && (
                                        <TableBody>
                                            {compz.map((x, i) => row(x, i, compTab, isLoading))}
                                        </TableBody>
                                    )}
                                </Table>
                            </TableWrapper>
                        </TableContainer>
                        {isLoading ? (
                            <AlternateContent>
                                <CircularProgress color="primary" />
                            </AlternateContent>
                        ) : Object.keys(compz).length > 0 ? null : (
                            <AlternateContent>Nothing to show.</AlternateContent>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const row = (x, index, compTab, isLoading) => {
    return isLoading ? null : (
        <TableRow key={`tr-${index}`} selectable="false">
            {schema.viewHeaders[compTab].map((y, k) =>
                y.name === "Address" ? (
                    <TableCell key={`trc-${k}`}>
                        <StyledLink to={`/comp/${x.dealKey}`}>
                            <ListingIdLink>{get(x, "listing.listingName", null)}</ListingIdLink>
                        </StyledLink>
                        <div>{buildAddress(get(x, "listing.property.primaryAddress", {}))}</div>
                    </TableCell>
                ) : y.transform ? (
                    y.name === "Brokers" ? (
                        <TableCell key={`trc-${k}`}>
                            <span data-tooltip-id={`comp-table-tooltip-${k}`} data-tooltip-content={get(x, y.prop)}>{y.transform(get(x, y.prop))}</span>
                            <Tooltip id={`comp-table-tooltip-${k}`} place="top" style={{backgroundColor: '#333',color: '#fff',fontSize: '0.8rem'}} />
                        </TableCell>
                    ) : (
                        <TableCell key={`trc-${k}`}>
                            {y.transform(get(x, y.prop))}
                        </TableCell>
                    )
                ) : (
                    //no transform function
                    <TableCell key={`trc-${k}`}>
                        {get(x, y.prop)}
                    </TableCell>
                )
            )}
        </TableRow>
    );
};

export default CompsTable;